import apiClient from './apiClient';

const currentUserPermissionService = {
  /**
   * Get current user permissions
   * @returns {Promise<Array>} Array of user permissions
   */
  async getCurrentUserPermissions() {
    try {
      const response = await apiClient.get('/api/supplier/user-profile/current-user-permissions');
      return response.data;
    } catch (error) {
      console.error('Error fetching current user permissions:', error);
      throw error;
    }
  }
};

export default currentUserPermissionService; 